import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { getAllModulos, eliminarModulo } from "../../services/modulo.service";
import { getAllIdiomas } from "../../services/idioma.service";
import { getAllNiveles } from "../../services/nivel.service";

import { ModuloCard } from "./ModuloCard";
import { DataTable } from "../../components/organisms/DataTable";
import { paginacion } from "../../utils/paginacion/paginacion";

import {
  showDeletedAlert,
  showErrorAlert,
  showQuestionDeleteAlert,
  showUpdateAlert,
} from "../../components/molecules/ShowAlert";

const MODULOS_POR_PAGINA = 15;

export const ModuloList = () => {
  const navigate = useNavigate();
  const [modulos, setModulos] = useState([]);
  const [paginaActual, setPaginaActual] = useState(1);
  const [busqueda, setBusqueda] = useState("");

  useEffect(() => {
    cargarDatos();
  }, []);

  const cargarDatos = async () => {
    try {
      const [modulosApi, idiomasApi, nivelesApi] = await Promise.all([
        getAllModulos(),
        getAllIdiomas(),
        getAllNiveles(),
      ]);

      const modulosEnriquecidos = modulosApi.map((modulo) => ({
        ...modulo,
        idioma: idiomasApi.find((i) => i.idIdioma === modulo.idIdioma) || { nombre: "Sin idioma" },
        nivel: nivelesApi.find((n) => n.idNivel === modulo.idNivel) || { nombre: "Sin nivel" },
      }));

      setModulos(modulosEnriquecidos);
    } catch (error) {
      console.error("Error al cargar datos:", error);
    }
  };

  const handleEditModulo = (idModulo) => {
    showUpdateAlert({
      callback: () => navigate(`/modulos/actualizar/${idModulo}`),
    });
  };

  const handleDeleteModulo = (idModulo) => {
    showQuestionDeleteAlert({
      callback: async (result) => {
        if (result.isConfirmed) {
          try {
            await eliminarModulo(idModulo);
            showDeletedAlert({ callback: cargarDatos });
          } catch (error) {
            console.error("Error al eliminar módulo:", error);
            showErrorAlert();
          }
        }
      },
    });
  };

  const normalizarTexto = (texto) =>
    texto?.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "") || "";
  
  const modulosFiltrados = modulos.filter(({ nombre, sigla, idioma, nivel, estado }) => {
    const texto = normalizarTexto(busqueda);
    return (
      normalizarTexto(nombre).includes(texto) ||
      normalizarTexto(sigla).includes(texto) ||
      normalizarTexto(idioma?.nombre).includes(texto) ||
      normalizarTexto(nivel?.nombre).includes(texto) ||
      normalizarTexto(estado).includes(texto)
    );
  });  
  

  const {
    objetosEnPagina: modulosEnPagina,
    paginas,
    paginaInicial,
    paginaFinal,
  } = paginacion(paginaActual, modulosFiltrados, MODULOS_POR_PAGINA);

  const columnas = ["#", "Nombre", "Sigla", "Idioma", "Nivel", "Estado", "Opciones"];

  return (
    <section className="px-4 pb-10 max-w-6xl mx-auto">
      <div className="flex justify-between items-center my-4">
        <input
          type="text"
          placeholder="Buscar por nombre, sigla, idioma, nivel o estado..."
          value={busqueda}
          onChange={(e) => {
            setPaginaActual(1);
            setBusqueda(e.target.value);
          }}
          className="border border-gray-300 rounded px-4 py-2 w-full max-w-md"
        />
      </div>

      <DataTable
        columnas={columnas}
        paginas={paginas}
        paginaInicial={paginaInicial}
        paginaFinal={paginaFinal}
        paginaActual={paginaActual}
        setPaginaActual={setPaginaActual}
      >
        {modulosEnPagina.map((modulo, index) => (
          <ModuloCard
            key={modulo.idModulo}
            modulo={modulo}
            index={(paginaActual - 1) * MODULOS_POR_PAGINA + index + 1}
            onEdit={handleEditModulo}
            onDelete={handleDeleteModulo}
          />
        ))}
      </DataTable>
    </section>
  );
};
